import { useCallback, useRef } from "react";

/** Browser Web Speech API (free, Chrome/Edge). start() begins live recognition; stop() resolves the transcript. */
export function useBrowserSpeech() {
  const recRef = useRef(null);
  const textRef = useRef("");
  const supported = typeof window !== "undefined" && !!(window.SpeechRecognition || window.webkitSpeechRecognition);

  const start = useCallback(() => {
    if (!supported) return false;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = navigator.language || "en-US";
    textRef.current = "";
    rec.onresult = (e) => {
      let finalText = "";
      for (let i = 0; i < e.results.length; i++) finalText += e.results[i][0].transcript + (e.results[i].isFinal ? " " : "");
      textRef.current = finalText.trim();
    };
    rec.onerror = () => {};
    try { rec.start(); recRef.current = rec; return true; } catch { return false; }
  }, [supported]);

  const stop = useCallback(() => new Promise((resolve) => {
    const rec = recRef.current;
    if (!rec) return resolve("");
    recRef.current = null;
    let settled = false;
    const done = () => { if (!settled) { settled = true; resolve(textRef.current || ""); } };
    rec.onend = done;
    setTimeout(done, 1200);
    try { rec.stop(); } catch { done(); }
  }), []);

  return { supported, start, stop };
}
